import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Auth } from '@aws-amplify/auth';
import CognitoConfig from './CognitoConfig';
import '@fortawesome/fontawesome-free/css/all.css';

// Amplify.configure({
//     Auth: {
//         region: 'ap-southeast-1',
//         userPoolId: 'ap-southeast-1_wyUuKvy4m',
//         userPoolWebClientId: '3hsk0a6kmu2bsspju3ij8nlpp',
//    }
// });
Amplify.configure(CognitoConfig);

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        checkUser();
    }, [isLoggedIn]);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    async function checkUser() {
        try {
            await Auth.currentAuthenticatedUser();
            console.log('finished checking log in status');
            navigate('/mainmenu');
            setIsLoggedIn(true);
            
        } catch {
            console.log('User not logged in');
            setIsLoggedIn(false);
        }
    }
  
    const onSubmit = async (event) => {
        event.preventDefault();
        try {
            const user = await Auth.signIn(username, password);

            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                Auth.completeNewPassword(user, password);
            }
            else{
                navigate('/mainmenu');
            }
        } catch (error) {
            console.error('Login failure:', error);
            setError(error.message || 'Authentication failed');
        }
    };


    return (

      <div className="flex-container-1">                  
        <div className="upload-container">
  
            <div className="menu-title-container">
                <div className="menu-title-text">Login to CRSP Admin</div>
            </div>

            <form className="login-form-spacer" onSubmit={onSubmit}>

                <div className="login-question-container">
                <label className="login-label">User Name</label>
                
                <input 
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                    type="text"
                />
                </div>  

                    <div className="login-question-container">
                            <label className="login-label">Password</label>
                            <div className="password-wrapper">
                                <input 
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                    type={showPassword ? "text" : "password"}
                                />
                                <button type="button" className="toggle-password" onClick={togglePasswordVisibility}>{showPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}</button>
                        </div>
                    </div>

                    {error && (
                    <div className="login-question-container">
                        <label className="login-error-message">{error}</label>
                        </div>
                    
                    )}

                    <div className="login-button-container">
                            <button className="login-submit-button" type="submit">Login</button>
                    </div>
    
                </form>
              </div>

              

        </div>
     
       
    );
};

export default Login;
